import { Component, Input } from '@angular/core';

import { CustomIcon, IconLibrary } from '@finnairoyj/fcom-ui-styles/enums';
import { Observable, map } from 'rxjs';

import { CmsTaxonomyGeneral } from '@fcom/core-api';

import { ElementTypes } from '../../interfaces';
import { NavigationMenuService } from '../../services';

@Component({
  selector: 'fin-footer',
  styleUrls: ['./footer.component.scss'],
  templateUrl: './footer.component.html',
  standalone: false,
})
export class FooterComponent {
  @Input()
  content$: Observable<any>;

  readonly isVisible$: Observable<boolean>;
  readonly CmsTaxonomyGeneral = CmsTaxonomyGeneral;
  readonly CustomIcon = CustomIcon;
  readonly IconLibrary = IconLibrary;

  readonly menuItems$: Observable<any>;
  public readonly ElementTypes = ElementTypes;

  constructor(public navigationMenuService: NavigationMenuService) {
    this.menuItems$ = this.navigationMenuService.menuItems$.pipe(map((data) => data.bottom));
    this.isVisible$ = this.navigationMenuService.isFooterVisible$;
  }
}
